import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiCenter } from '../../api/ApiCenter';
import { Button, Form, Radio, Space } from 'antd';
import classes from './style/TestQuestions.module.css';
import { UI_Footer } from '../../../Core/Core';
interface Theme {
  id: number;
  category_id: number;
  title: string;
  is_visible: boolean;
  is_draft: boolean;
}

interface Questions {
  id: number;
  test_id: number;
  text: string;
  answers: {
    id: number;
    question_id: number;
    is_right: boolean;
    text: string;
  }[];
}
interface Quiz {
  id: number;
  theme_id: number;
  title: string;
  questions_count: number;
  theme: Theme;
  questions: Questions[];
}
interface IonFinish {
  id: number;
  answers: number[];
}
interface TestData {
  success: boolean;
  message: string;
  data: {
    test_result: TestResult;
  };
}

interface TestResult {
  id: number;
  user_id: number;
  test_id: number;
  points: number;
  questions_count: number;
  is_passed: boolean;
  complete_date: string;
}
const TestQuestions = () => {
  const { id } = useParams();
  const ApiStart = new ApiCenter();
  const [data, setData] = useState<Quiz>();
  const [form] = Form.useForm();
  const [messageApi, setMessageApi] = useState<TestData>();
  useEffect(() => {
    ApiStart.GET_API('hr/test/' + id).then((response: any) => {
      if (response.success) {
        setData(response.data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!data) {
    return <>Нет данных</>;
  }
  const onFinish = (value: IonFinish) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resultMap = Object.entries(value).map(([key, item]) => {
      return item;
    });
    ApiStart.GET_API(`hr/test/${id}/solution`, 'POST', resultMap).then((response: TestData) => {
      setMessageApi(response);
    });
  };
  return (
    <>
      <Form form={form} name="Test" onFinish={onFinish} autoComplete="off" layout="vertical">
        <div className={classes.questionsText}>Список вопросов:</div>
        {data?.questions?.map((item, index: number) => {
          return (
            <div className={classes.WrapperAnswer} key={item.id}>
              <div className={classes.AnswerTitle}>Вопрос {index + 1}.</div>
              <Form.Item
                name={`id+${item.id}`}
                label={<h1>{item?.text}</h1>}
                rules={[{ required: true, message: 'Please pick an item!' }]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    {item.answers.map((answer) => {
                      return (
                        <React.Fragment key={answer.id}>
                          <Radio value={{ id: answer.question_id, answers: [answer.id] }}>
                            {answer.text}
                          </Radio>
                        </React.Fragment>
                      );
                    })}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </div>
          );
        })}
        <UI_Footer>
          <div style={{ display: 'flex', gap: '10px' }}>
            <div>Результаты теста:</div>
            <div style={{ color: messageApi?.data?.test_result?.is_passed ? 'green' : 'red' }}>
              {messageApi?.message} из {messageApi?.data.test_result?.questions_count}
            </div>
          </div>
          <Button type="default" htmlType="submit">
            Проверить результаты
          </Button>
        </UI_Footer>
      </Form>
    </>
  );
};

export default TestQuestions;
